import { useMutation, useQueryClient } from "@tanstack/react-query";
import { settlementKeys } from "@/components/pages/settlement/hooks/useSettlement";
import { bookingCheckoutService } from "@/services/booking-checkout.service";
import type { SendPreCheckoutReminderResponse } from "@/services/booking-checkout.service";
import type { Reservation } from "@/types/reservation";
import { reservationKeys } from "@/hooks/useReservations";

export const useSendPreCheckoutReminder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (bookingId: string) =>
      bookingCheckoutService.sendPreCheckoutReminder(bookingId),
    onSuccess: (response: SendPreCheckoutReminderResponse) => {
      queryClient.setQueryData<Reservation>(
        reservationKeys.detail(response.bookingId),
        (current) =>
          current
            ? {
                ...current,
                preCheckoutStatus: response.preCheckoutStatus,
              }
            : current,
      );
      queryClient.invalidateQueries({ queryKey: reservationKeys.all });
      queryClient.invalidateQueries({ queryKey: settlementKeys.all });
    },
  });
};
